import { Text } from '@americastestkitchen/mise';
import { PrintFontOptions } from 'types/recipe';

const DetailPageHeaderMeta = ({
  label,
  value,
}: {
  label: string;
  value: string | null;
  printSize?: PrintFontOptions;
}) =>
  value ? (
    <p>
      <Text variant="labelPrimary" weight="bold">
        {label}{' '}
      </Text>
      <Text variant="bodyPrimaryShort">{value}</Text>
    </p>
  ) : null;

export default DetailPageHeaderMeta;
